let $ = jQuery;

module.exports = {

  scrollerClass: '.js-horiz-scroll',
  scrollContentWrapperClass: '.js-horiz-scroll__wrapper',
  scrollerContentClass: '.js-horiz-scroll__content',
  scrollerItemClass: '.js-horiz-scroll__item',
  scrollerNavClass: '.js-horiz-scroll__nav',
  scrollerNavItemClass: '.js-horiz-scoll__nav-item',

  attach: function (context, settings) {

    var that = this;
    var $jsScroller = $(context).find(this.scrollerClass);

    if ($jsScroller.length > 0) {

      // Need to adjust the scrollers to make them look nice.
      $.each($jsScroller, function(index, elem) {
        that.adjustScrollerOffsets(elem);

        // Store the wrapper element -- that is what gets scrolled.
        // We store info on it too, about it's position and children offsets.
        var $wrapper = $(elem).find(that.scrollerContentClass);
        $wrapper.lastScrollPos = 0;
        $wrapper.delta = 0;
        $wrapper.childrenInfo = [];
        $wrapper.activeItem = 0;

        $.each($wrapper.find(that.scrollerItemClass), function(index, elem) {
          $wrapper.childrenInfo.push(that.getChildInfo($(elem)));
        });

        $wrapper.scroll({context: that, wrapper: $wrapper}, that.handleScroll);

        $(elem).on('click', that.scrollerNavItemClass, {context: that, wrapper: $wrapper}, that.handleClick);
      });
    }
  },

  adjustScrollerOffsets: function(scroller) {
    var $scroller = $(scroller);
    var $scrollerItems = $scroller.find(this.scrollerItemClass);
    var lastItemIndex = $scrollerItems.length - 1;
    var $lastItem = $scrollerItems.eq(lastItemIndex);

    $lastItem.css('margin-right', 'calc(100% - ' + $lastItem.width() + 'px)');
  },

  handleClick: function(e) {
    var that = e.data.context;
    var $wrapper = e.data.wrapper;
    var $target = $(e.target);

    if ($target.hasClass('active')) {
      return;
    }
    else {
      that.moveScroller($target, $wrapper, that);
    }
  },

  handleScroll: function(e) {
    var that = e.data.context;
    var $wrapper = e.data.wrapper;
    var $items = $wrapper.find(that.scrollerItemClass);
    var $buttons = $wrapper.parents(that.scrollContentWrapperClass).siblings(that.scrollerNavClass).find(that.scrollerNavItemClass);
    var buffer = 10;
    var currPos = $wrapper.scrollLeft();
    var delta = $wrapper.lastScrollPos - currPos;
    var dir = delta <= 0 ? 'left' : 'right';

    if (dir === 'left') {
      var i = 1;

      for (i; i < $wrapper.childrenInfo.length; i++) {
        if ($wrapper.activeItem < i && currPos > $wrapper.childrenInfo[i].offset - $wrapper.childrenInfo[i - 1].gutter) {
          $wrapper.activeItem = i;
          that.setNavStyles($buttons, $buttons.eq(i));
        }
      }
    }
    else if (dir === 'right') {
      var i = $wrapper.childrenInfo.length - 1;

      for (i; i >= 0; i--) {
        if ($wrapper.activeItem > i && currPos <= $wrapper.childrenInfo[i].offset) {
          $wrapper.activeItem = i;
          that.setNavStyles($buttons, $buttons.eq(i));
        }
      }
    }

    $wrapper.lastScrollPos = $wrapper.scrollLeft();
  },

  moveScroller: function($target, $wrapper, that) {
    var $parent = $target.parents(that.scrollerClass);
    var $navItems = $parent.find(that.scrollerNavItemClass);
    var $wrapper = $parent.find(that.scrollerContentClass);
    var index = $target.index();
    var $activeItem = $parent.find(that.scrollerItemClass).eq(index);
    // Set activeItem.
    $wrapper.activeItem = index;
    // Get offset.
    var childInfo = that.getChildInfo($activeItem);

    // Change active nav item.
    that.setNavStyles($navItems, $target);
    // Move scroller.
    $wrapper.animate({
      scrollLeft: childInfo.offset
    }, 250);
  },

  getChildInfo: function(item) {
    var childInfo = {
        offset: 0,
        width: item.outerWidth(),
        gutter: parseInt(item.css('margin-right')) + parseInt(item.css('margin-left'))
    };
    var prevItems = item.prevAll();

    $.each(prevItems, function(index, elem) {
      var $elem = $(elem);
      var margin = parseInt($elem.css('margin-right')) + parseInt($elem.css('margin-left'));

      childInfo.offset += $elem.outerWidth() + margin;
    });

    return childInfo;
  },

  setNavStyles: function($navItems, activeItem) {
    $navItems.removeClass('active');
    activeItem.addClass('active');
  }
};
